module.exports = __webpack_public_path__ + "static/media/team-member-03.78e5f521.jpg";